const E = "unknown", n = "10.22.1", o = `${n}+${E}`;
export {
  o as REPORT_PACKAGE_VERSION
};
